import styled from '@emotion/styled'

export const StyleColumn = styled.div<any>`
  display: flex;
  flex-direction: column;
  ${(props: any) => props.customStyle}
`
export const StyleRow = styled.div<any>`
  display: flex;
  flex-direction: row;
  ${(props: any) => props.customStyle}
`
export const StyleTableWrapper = styled.div<any>`
  display: block;
  width: 100%;
  background: ${(props: any) => props.theme.colors.white};
  ${(props: any) => props.customStyle}
`
export const StyleTable = styled.table<any>`
  border-collapse: collapse;
  width: 100%;
  ${(props: any) => props.customStyle}
`
export const StyleTableHead = styled.thead``
export const StyleTableRow = styled.tr<any>`
  cursor: pointer;
  border-bottom: ${(props) =>
    !!props.borderBottom
      ? `1px solid ${props.theme.colors.borderColor}`
      : 'none'};

  &:last-child {
    border-bottom: none;
  }
`

export const StyleTableHeader = styled.th<any>`
  font-size: ${(props) => props.theme.fontSizes['md']}px;
  color: ${(props) => props.theme.colors.black400};
  border-bottom: ${(props) => `1px solid ${props.theme.colors.borderColor}`};
  font-weight: 500;
  text-align: left;
  height: 35px;
  padding-left: 15px;
  padding-right: 10px;
  background: ${(props) => props.theme.colors.primary50};
  border: 1px solid rgba(255, 255, 255, 0.3);

  ${(props: any) => props.customStyle}
`
export const StyleTableBody = styled.tbody<any>``
export const StyleTableBodyText = styled.td<any>`
  font-size: ${(props) => props.theme.fontSizes['sm']}px;
  color: ${(props) =>
    !!props.color
      ? props.theme.colors[props.color]
      : props.theme.colors.black400};
  border-bottom: ${(props) =>
    !!props.borderBottom
      ? `1px solid ${props.theme.colors.borderColor}`
      : 'none'};
  padding-top: 15px;
  padding-bottom: 15px;
  padding-left: 15px;
  padding-right: 10px;
  max-width: 300px;
  text-align: justify;
  ${(props: any) => props.customStyle}
`

export const StyleSearchInputWrapper = styled.div<any>`
  display: flex;
  border-radius: 4px;
  border: 1px solid ${(props) => props.theme.colors.borderColor};
  color: ${(props) => props.theme.colors.borderColor};
  padding: 8px 16px;
  width: 30%;
  height: ${(props: any) => props?.height || '34'}px;
  align-items: center;

  @media (max-width: 768px) {
    width: 200px;
    padding: 8px 12px;
  }

  @media (max-width: 480px) {
    padding: 6px 10px;
    height: 36px;
    width: 100%;
  }
`

export const StyleSearchInput = styled.input<any>`
  font-size: 14px;
  width: 100%;
  border: none;
  text-indent: 7px;
  color: ${(props) => props.theme.colors.black500};
  outline: none;
  ::placeholder {
    color: ${(props) => props.theme.colors.borderColor};
  }
`

export const StyleActionButton = styled.button<any>`
  background: none;
  border: 1px solid
    ${(props: any) => props.theme.colors[props?.borderColor || 'primary']};
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 6px 12px;
  border-radius: 4px;
  height: 26px;
`

export const StyleActionIconButton = styled.button`
  background: none;
  border: 0px;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`

export const StyleNotFoundWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const StyleActionButtonTitle = styled.p<any>`
  font-size: 12px;
  font-weight: 500;
  color: ${(props: any) => props.theme.colors[props?.tc || 'primary']};
  line-height: 14.4px;
`

export const StyleTableUserLabel = styled.p<any>`
  font-size: 14px;
  font-weight: 400;
  color: ${(props: any) => props.theme.colors[props?.tc || 'black500']};

  ${(props: any) => props.customStyle}
`
export const StyleUserInfoRow = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 6px;
  align-items: center;
`
export const StyleUserInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`
